<template>
  <div class="card is-smallshadow">
    <div class="card-body py-3">
      <h2 class="heading-small text-grey mb-2">
        {{ $t('adviserSettings.logoAndColors') }}
      </h2>

      <div>
        <validation-observer
          ref="adviser-settings-email-form"
          tag="form">

          <div class="form-group">
            <label>
              {{ $t('adviserSettingsEmailInfo.logo') }}
            </label>

            <div>
              <template v-if="data.email_logo_url">
                <img
                  class="profie-image mb-1 mt-1"
                  :src="data.email_logo_url" />
              </template>
              <template v-else-if="data.email_logo">
                <span>{{ data.email_logo.name }}</span>
              </template>

              <div
                v-if="data.email_logo_url"
                class="text-left pt-1">
                <f-button
                  theme="danger"
                  @click.prevent="removeEmailLogo()">
                  {{ $t('adviserSettingsBusinessCardInfo.deletePhoto') }}
                </f-button>
              </div>

              <f-file-input
                v-if="!data.email_logo"
                :onChange="setEmailLogo"
                id="inputFileEmailLogo" />
            </div>
          </div>

          <div class="form-group">
            <label>
              {{ $t('adviserSettingsEmailInfo.generalColor') }}
            </label>

            <span>{{ $t('adviserSettingsEmailInfo.currentColor') }} </span>
            <template v-if="data.email_main_color">
              <div
                class="current-color mt-1"
                :style="'background: ' + data.email_main_color">

              </div>
            </template>
            <template v-else>
              <span>{{ $t('ui.none') }}</span>
            </template>

            <div class="mt-2 mb-1">{{ $t('adviserSettingsEmailInfo.selectNewColor') }} </div>
            <swatch-picker
              v-model="defaultMainColor"/>
          </div>
        </validation-observer>

        <div class="text-right mt-1">
          <f-button
            theme="primary"
            big
            :disabled="actionInProgress"
            @click.prevent="sendTestEmail">
            {{ $t('communicationMail.sendTestMail') }}
          </f-button>
        </div>
      </div>
    </div>
    <div class="card-footer pt-3 pb-4 text-right">
      <f-button
        theme="primary"
        big
        @click.prevent="validateForm">
        {{ $t('ui.save') }}
      </f-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';

export default {
  name: 'adviser-settings-email-info',
  props: {
    emailMainColor: {
      type: String
    },
    emailMainColorUrl: {
      type: String
    },
    emailLogo: {
      type: String
    },
    emailLogoUrl: {
      type: String
    },
    adviserEmail: {
      type: String
    }
  },
  data() {
    return {
      data: {
        email_main_color: null,
        email_logo: null,
        email_logo_url: null
      },
      defaultMainColor: {
        hex: '#023047',
      },
      actionInProgress: false
    }
  },
  mounted() {
    this.data.email_main_color = this.emailMainColor;
    this.data.email_logo = this.emailLogo;
    this.data.email_logo_url = this.emailLogoUrl;

    if (this.emailMainColor) {
      this.defaultMainColor.hex = this.emailMainColor;
    }
  },
  methods: {
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();

      let fileParams = [];
      if (formDataToSend.email_logo) {
        fileParams.push('file');
      }

      FormUtils.submit(this, {
        endpoint: '/api/adviser/adviser/update-email-settings',
        formData: formDataToSend,
        successTitle: this.$t('ui.savedChanges'),
        successText: this.$t('adviserSettings.yourDataHasBeenSaved'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('adviserSettings.yourDataModifyError'),
        successAction: () => {
          this.$bus.$emit('adviser-settings-reload', true);
        }
      }, fileParams);
    },
    validateForm () {
      FormUtils.validate(this.$refs['adviser-settings-email-form'], this.submitForm);
    },
    setEmailLogo (event) {
      Vue.set(this.data, 'email_logo', event.target.files[0]);
    },
    removeEmailLogo () {
      Vue.set(this.data, 'email_logo_url', '');
      Vue.set(this.data, 'email_logo', '');
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        email_logo: this.data.email_logo,
        email_main_color: this.defaultMainColor.hex
      };

      return formDataToSend;
    },
    updateData (newData) {
      this.data.email_main_color = newData.email_main_color;
      this.data.email_logo = newData.email_logo;
      this.data.email_logo_url = newData.email_logo_url;
    },
    sendTestEmail () {
      this.actionInProgress = true;

      let formDataToSend = {
        email: this.adviserEmail
      };

      FormUtils.submit(this, {
        endpoint: '/api/adviser/adviser/send-test-email',
        formData: formDataToSend,
        successTitle: this.$t('communicationMail.emailSend.emailSendSuccess'),
        successText: this.$t('adviserSettingsEmailInfo.sendTestMailMessage'),
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('adviserSettingsEmailInfo.sendTestMailMessageError'),
        successAction: () => {
          this.actionInProgress = false;
        },
        failAction: () => {
          this.actionInProgress = false;
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.current-color {
  border-radius: 4px;
  height: 44px;
  width: 44px;
}

</style>
